import { Box, Chip } from "@mui/material";
import { Container } from "Components/Container";
import { Column } from "Components/Grid";
import { useQuery } from "react-query";
import { useNavigate, useParams } from "react-router-dom";
import { ColumnEdit, LinkEdit, RowExhibition } from "./styles";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { getUserById } from "services/users-service";
import { getCompanyRolesBySlug } from "services/company-service";
import { PageLoaderShow } from "Components/PageLoader/Show";
import { useSelector } from "react-redux";
import { useAuthTenant } from "store/auth";
import { useCountryConfig } from "hooks/useCountryConfig";
import { useTranslation } from "react-i18next";

export const UsersShow = () => {
  const { t } = useTranslation(['user', 'common']);
  const navigate = useNavigate();
  const { id } = useParams();
  const selectedTenant = useSelector(useAuthTenant);
  const { phonePrefix } = useCountryConfig(selectedTenant?.country);

  const {
    isLoading,
    error,
    data: user,
  } = useQuery("getUserById", async () => {
    const dataUser = await getUserById(id);

    return dataUser.status === 200 ? dataUser.data : null;
  });
  const {
    isLoading: loadingRoles,
    error: errorRoles,
    data: roles,
  } = useQuery("getRoleCompanyBySlug", async () => {
    if (selectedTenant.slug === undefined) return [];
    const dataRoles = await getCompanyRolesBySlug(selectedTenant.slug);

    return dataRoles.status === 200 ? dataRoles.data : null;
  });

  const onClickEdit = () => {
    navigate("/users/edit/" + id);
  };

  return (
    <>
      {!isLoading && !error && (
        <Container title={`${user?.name}`} breadcrumb={`${t('user:users.breadcrumb')} / ${user?.name}`} linkPage="/users">
          <Box sx={{ width: "100%" }} className="container">
            <Box sx={{ p: 3 }}>
              <RowExhibition>
                <Column xs={3}>{t('user:users.show.name')}</Column>
                <Column>{user.name}</Column>
                <ColumnEdit xs={2}>
                  <LinkEdit onClick={onClickEdit}>
                    <EditOutlinedIcon style={{ fill: "#0039C5" }} />
                    {t('user:users.show.edit')}
                  </LinkEdit>
                </ColumnEdit>
              </RowExhibition>
              <RowExhibition>
                <Column xs={3}>{t('user:users.show.email')}</Column>
                <Column>{user.email}</Column>
                <ColumnEdit xs={2}>
                  <LinkEdit onClick={onClickEdit}>
                    <EditOutlinedIcon style={{ fill: "#0039C5" }} />
                    {t('user:users.show.edit')}
                  </LinkEdit>
                </ColumnEdit>
              </RowExhibition>
              <RowExhibition>
                <Column xs={3}>{t('user:users.show.phone')}</Column>
                <Column>{user.cellphone ? `${phonePrefix} ${user.cellphone}` : ''}</Column>
                <ColumnEdit xs={2}>
                  <LinkEdit onClick={onClickEdit}>
                    <EditOutlinedIcon style={{ fill: "#0039C5" }} />
                    {t('user:users.show.edit')}
                  </LinkEdit>
                </ColumnEdit>
              </RowExhibition>
              <RowExhibition>
                <Column xs={3}>{t('user:users.show.permission')}</Column>
                <Column>
                  {!loadingRoles &&
                    !errorRoles &&
                    user.permissions
                      ?.filter(permission => permission.companyKey === selectedTenant.slug)
                      .map(permission => (
                        <Chip
                          key={`${permission.companyKey}`}
                          label={roles.find(role => role.roleKey === permission.roleKey)?.roleName}
                          variant="outlined"
                          color="primary"
                          sx={{
                            width: "fit-content",
                          }}
                        />
                      ))}
                </Column>
                <ColumnEdit xs={2}>
                  <LinkEdit onClick={onClickEdit}>
                    <EditOutlinedIcon style={{ fill: "#0039C5" }} />
                    {t('user:users.show.edit')}
                  </LinkEdit>
                </ColumnEdit>
              </RowExhibition>
              <RowExhibition>
                <Column xs={3}>{t('user:users.show.active')}</Column>
                <Column>{user.active ? t('common:boolean.yes') : t('common:boolean.no')}</Column>
                <ColumnEdit xs={2}>
                  <LinkEdit onClick={onClickEdit}>
                    <EditOutlinedIcon style={{ fill: "#0039C5" }} />
                    {t('user:users.show.edit')}
                  </LinkEdit>
                </ColumnEdit>
              </RowExhibition>
              <RowExhibition>
                <Column xs={3}>{t('user:users.show.group')}</Column>
                <Column>
                  {user.groups
                    ?.filter(group => group.companyKey === selectedTenant.slug)
                    .map(group => (
                      <Chip
                        key={group.name}
                        label={group.name}
                        variant="outlined"
                        color="primary"
                        sx={{
                          width: "fit-content",
                        }}
                      />
                    ))}
                </Column>
                <ColumnEdit xs={2}>
                  <LinkEdit onClick={onClickEdit}>
                    <EditOutlinedIcon style={{ fill: "#0039C5" }} />
                    {t('user:users.show.edit')}
                  </LinkEdit>
                </ColumnEdit>
              </RowExhibition>
            </Box>
          </Box>
        </Container>
      )}
      {isLoading && <PageLoaderShow />}
      {error && <div>{t('user:users.show.error')}</div>}
    </>
  );
};
